<particle-status-iconic-cell-viewer
  *ngIf="item && item?.cells && item?.cells['Status'] && item?.cells['Status']?.displayText"
  [status]="item.cells['Status'].displayText"
  [statusTitle]="item.cells['StatusTitle']?.displayText"
></particle-status-iconic-cell-viewer>
